import Scanner from '../components/Scanner'
import { connect } from 'react-redux'
import {startScan, disconnect, disconnectProcessing} from "../modules/scanner";

const mapDispatchToProps = {
  startScan,
  disconnect,
  disconnectProcessing
};

const mapStateToProps = (state) => ({
  scanner_server_status: state.scanner.scanner_server_status
});

export default connect(mapStateToProps, mapDispatchToProps)(Scanner)


// WEBPACK FOOTER //
// ./src/components/Devices/Scanner/containers/ScannerContainer.js